module.exports = __webpack_public_path__ + "static/media/tripplo.75cc1060.svg";